import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/newPhone/default.svg'
import _imports_1 from '@/assets/earth.svg'


const _withScopeId = n => (_pushScopeId("data-v-014983cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mod_wrap mod_set_wrap select_none" }
const _hoisted_2 = { class: "mod_c_title" }
const _hoisted_3 = {
  key: 1,
  class: "wrap_info"
}
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "community_second_two" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "container_bg" }
const _hoisted_8 = { class: "container_son" }
const _hoisted_9 = { class: "container_sonm" }
const _hoisted_10 = { class: "container_sonse" }
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "container_in_img",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_13 = { class: "content" }
const _hoisted_14 = { class: "container_tab" }
const _hoisted_15 = { class: "container_tab_table" }
const _hoisted_16 = { class: "content_ul" }
const _hoisted_17 = { class: "cetp_input_wrap_change" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cetp_earth" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_19 = { class: "content_first" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "more" }, "中文名称 :", -1))
const _hoisted_21 = { class: "content_first" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "more" }, "中文按钮 :", -1))
const _hoisted_23 = { class: "content_first" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "more" }, "中文描述 :", -1))
const _hoisted_25 = { class: "content_first" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "more" }, "英文名称 :", -1))
const _hoisted_27 = { class: "content_first" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "more" }, "英文按钮 :", -1))
const _hoisted_29 = { class: "content_first" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "more" }, "英文描述 :", -1))
const _hoisted_31 = { class: "content_second" }
const _hoisted_32 = { class: "content_fourth" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "more" }, "弹出开关 : ", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "开启可在观众打开直播间自动弹出二维码", -1))
const _hoisted_35 = { class: "text_upload" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "more" }, "上传二维码 : ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Crumb = _resolveComponent("Crumb")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_c_loading = _resolveComponent("c-loading")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_QuestionCircleFilled = _resolveComponent("QuestionCircleFilled")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_c_upload = _resolveComponent("c-upload")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Crumb, { showliveInfo: "" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(" 公众号设置 "),
        _createVNode(_component_a_switch, {
          class: "btns_txt",
          checkedValue: 0,
          unCheckedValue: 1,
          checked: _ctx.matics,
          "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.matics) = $event)),
          onChange: _ctx.save
        }, null, 8, ["checked", "onChange"])
      ]),
      (_ctx.showLoading)
        ? (_openBlock(), _createBlock(_component_c_loading, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, [
                _withDirectives(_createElementVNode("img", {
                  src: _ctx.chart,
                  alt: ""
                }, null, 8, _hoisted_6), [
                  [_vShow, _ctx.chart]
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.select == 1 ? _ctx.official : _ctx.englishName), 1),
                _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.select == 1 ? _ctx.item : _ctx.englishdecribe), 1),
                _createElementVNode("p", _hoisted_10, [
                  _createElementVNode("img", {
                    src: _ctx.imageUrl,
                    alt: "",
                    class: "container_sonse_img"
                  }, null, 8, _hoisted_11)
                ])
              ]),
              _hoisted_12
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("ul", _hoisted_16, [
                    _createElementVNode("li", null, [
                      _createElementVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _createElementVNode("div", {
                          class: "cept_china",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.select = 1)),
                          style: _normalizeStyle({ color: _ctx.select == 2 ? '#ccc' : '' })
                        }, "中", 4),
                        _createTextVNode(" / "),
                        _createElementVNode("div", {
                          class: "cept_eng",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.select = 2)),
                          style: _normalizeStyle({ color: _ctx.select == 1 ? '#ccc' : '' })
                        }, "ENG", 4)
                      ])
                    ]),
                    _withDirectives(_createElementVNode("li", _hoisted_19, [
                      _hoisted_20,
                      _createVNode(_component_a_input, {
                        class: "cetp_input_wrap_input",
                        value: _ctx.official,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.official) = $event)),
                        placeholder: "请输入内容"
                      }, null, 8, ["value"])
                    ], 512), [
                      [_vShow, _ctx.select ? _ctx.select == 1 : '']
                    ]),
                    _withDirectives(_createElementVNode("li", _hoisted_21, [
                      _hoisted_22,
                      _createVNode(_component_a_input, {
                        class: "cetp_input_wrap_input",
                        value: _ctx.chinabutton,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.chinabutton) = $event)),
                        placeholder: "请输入内容"
                      }, null, 8, ["value"])
                    ], 512), [
                      [_vShow, _ctx.select ? _ctx.select == 1 : '']
                    ]),
                    _withDirectives(_createElementVNode("li", _hoisted_23, [
                      _hoisted_24,
                      _createVNode(_component_a_input, {
                        class: "cetp_input_wrap_input",
                        value: _ctx.item,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.item) = $event)),
                        placeholder: "请输入内容"
                      }, null, 8, ["value"])
                    ], 512), [
                      [_vShow, _ctx.select ? _ctx.select == 1 : '']
                    ]),
                    _withDirectives(_createElementVNode("li", _hoisted_25, [
                      _hoisted_26,
                      _createVNode(_component_a_input, {
                        class: "cetp_input_wrap_input",
                        value: _ctx.englishName,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.englishName) = $event)),
                        placeholder: "请输入内容"
                      }, null, 8, ["value"])
                    ], 512), [
                      [_vShow, _ctx.select ? _ctx.select == 2 : '']
                    ]),
                    _withDirectives(_createElementVNode("li", _hoisted_27, [
                      _hoisted_28,
                      _createVNode(_component_a_input, {
                        class: "cetp_input_wrap_input",
                        value: _ctx.englishbutton,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.englishbutton) = $event)),
                        placeholder: "请输入内容"
                      }, null, 8, ["value"])
                    ], 512), [
                      [_vShow, _ctx.select ? _ctx.select == 2 : '']
                    ]),
                    _withDirectives(_createElementVNode("li", _hoisted_29, [
                      _hoisted_30,
                      _createVNode(_component_a_input, {
                        class: "cetp_input_wrap_input",
                        value: _ctx.englishdecribe,
                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.englishdecribe) = $event)),
                        placeholder: "请输入内容"
                      }, null, 8, ["value"])
                    ], 512), [
                      [_vShow, _ctx.select ? _ctx.select == 2 : '']
                    ]),
                    _createElementVNode("li", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _hoisted_33,
                        _createVNode(_component_a_switch, {
                          class: "btns_txt",
                          checkedValue: 0,
                          unCheckedValue: 1,
                          checked: _ctx.Singlechoice,
                          "onUpdate:checked": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.Singlechoice) = $event))
                        }, null, 8, ["checked"]),
                        _createVNode(_component_a_popover, { placement: "right" }, {
                          content: _withCtx(() => [
                            _hoisted_34
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_QuestionCircleFilled, { class: "QuestionCircleFilled" })
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _hoisted_36,
                        _createVNode(_component_c_upload, {
                          "file-list": _ctx.fileList,
                          "handle-change": _ctx.handleChange,
                          loading: _ctx.loading,
                          "image-name": _ctx.imageUrl,
                          "click-stop": _ctx.imageDel,
                          class: "ant_upload"
                        }, null, 8, ["file-list", "handle-change", "loading", "image-name", "click-stop"])
                      ])
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_a_button, {
                        class: "table_button",
                        onClick: _ctx.save,
                        type: "primary",
                        disabled: _ctx.disBtn
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("保存")
                        ]),
                        _: 1
                      }, 8, ["onClick", "disabled"])
                    ])
                  ])
                ])
              ])
            ])
          ]))
    ])
  ], 64))
}